import { get } from 'api';

export const getAppsList = (owner: string, repo: string) =>
  get({
    url: `/${owner}/${repo}/apps`,
  });
